module.exports = __webpack_public_path__ + "a4d31128b633bc0b1cc1f18a34fb3851.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/material-design-iconic-font/fonts/Material-Design-Iconic-Font.woff2
// module id = 305
// module chunks = 1